import sanitizeHTML from 'sanitize-html'

const getAllowedTags = () => {
  const customTags = [
    'button',
    'img',
    'option',
    'input',
    'textarea',
    'label',
    'select'
  ]
  const forbiddenTags = ['iframe', 'a']
  return sanitizeHTML.defaults.allowedTags
    .concat(customTags)
    .filter(tag => !forbiddenTags.includes(tag))
}

const getAllowedAttributes = () => {
  return {
    '*': [
      'width',
      'height',
      'hidden',
      'placeholder',
      'rows',
      'cols',
      'class',
      'id',
      'type',
      'value',
      'resource',
      'text',
      'checked',
      'name',
      'max',
      'min',
      'selected'
    ]
  }
}

export const sanitize = html => {
  return sanitizeHTML(html, {
    allowedAttributes: getAllowedAttributes(),
    allowedTags: getAllowedTags()
  })
}

export default {
  install(Vue) {
    Vue.prototype.$sanitize = sanitize
  }
}
